export enum Industry {
  Carports = 'carports',
  Sheds = 'sheds',
  Buildings = 'buildings',
  RedIron = 'red-iron',
  PostFrame = 'post-frame',
  Greenhouses = 'greenhouses',
  Containers = 'containers',
}
